
import AudioPlayer, { RHAP_UI } from 'react-h5-audio-player'
//The following did not work: We had to take the scss from the Github lib and include it in our scss files.
//import 'react-h5-audio-player/lib/styles.css'

import { setPlayerMode, setPlayListIndex } from 'redux/actions/harmonizeActions'
import { PLAYER_MODES } from 'redux/reducers/harmonizeReducer'
import {
    Close, List, MusicNote, QueueMusic,
    Lock, LockOpen, Public, Edit, TouchApp, FormatListNumbered
} from '@material-ui/icons'
import { useDispatch, useSelector } from 'react-redux'

import { useState, createRef } from 'react'
import { isAdminUser } from 'util/adminUtils.js'
import UserImage from 'components/image/UserImage'
import imagesStyles from 'assets/jss/material-kit-react/imagesStyles'
import { primaryColor } from 'assets/jss/material-kit-react.js'
import { useHistory } from 'react-router-dom'
import { isVeryNarrow } from 'util/screenUtils'
import { Snackbar, useMediaQuery } from '@material-ui/core'
import { displayHomeIcon } from 'util/brandUtils'
import { displayError } from 'util/screenUtils'
import { getStorageAccount } from 'redux/actions/accountActions'
import { ACCESS_TYPES } from 'components/vortex/CreateVortexRoom'
import { useEffect } from 'react'
import { downloadImageFile } from 'controllers/BackblazeController'
import ErrorLine from 'components/ErrorLine'
import { setPlayTime } from 'redux/actions/harmonizeActions'
import { setEngaged } from 'redux/actions/harmonizeActions'
import BlurDialog from 'components/utility/BlurDialog'
import { setContinuousPlay } from 'redux/actions/displayActions'
import { setAccruedCredits, setCreditPlayTime } from 'redux/actions/creditsActions'
import { getAvailableCredits } from 'controllers/CoreServiceController'
import Footer from 'components/Footer/Footer'
import { checkCreditUsage } from 'util/creditUtils'
import { setShowCollections } from 'redux/actions/harmonizeActions'
import Playlists from './Playlists'
import { getAccountId } from 'redux/actions/accountActions'
import { PLAYER_STATES } from 'redux/reducers/harmonizeReducer'
import TimerProgress from 'components/mint/TimerProgress'
import { setPlayCurrentSong } from 'redux/actions/harmonizeActions'
import { setPostSignInPage } from 'redux/actions/harmonizeActions'
import DisplayCredits from 'components/transaction/DisplayCredits'
import SequenceStudio from './SequenceStudio'
import { setAllowSwipe } from 'redux/actions/displayActions'
import { isSongPreview } from 'util/postUtils'
import { setPreview } from 'redux/actions/playerControlActions'
import { setCurrentCredits } from 'redux/actions/creditsActions'
import { setCurrentArtistCredits } from 'redux/actions/creditsActions'
import { setCurrentPromotionalCredits } from 'redux/actions/creditsActions'
import { previous } from 'util/playlistUtils'
import { nextBlock } from 'util/playlistUtils'

let currentPlayTime
/** We use user instead of userId because that is what the Social Service db uses. */
export default function HarmonizePlayer({
    setCollectionPlaylist, messageSocket }) {
    const veryNarrow = isVeryNarrow(useMediaQuery)

    const playerStyles = {
        chatIcon: {
            fontSize: veryNarrow ? '1.5em' : '2em'
        },
        controlIcon: {
            fontSize: veryNarrow ? '1.5em' : '2em',
            marginRight: veryNarrow ? '0.25em' : '1em'
        },

        randomControlIcon: {
            fontSize: veryNarrow ? '1em' : '1.5em',
            marginRight: veryNarrow ? '0.25em' : '.5em'
        },
        likeIcon: {
            fontSize: veryNarrow ? '1.5em' : '2em',
        },
        helpLine: {
            display: 'flex', alignItems: 'center', fontSize: veryNarrow ? '0.9em' : 'inherit', borderBottom: '0.5px dashed black'
        },
        shareIcon: {
            fontSize: veryNarrow ? '1em' : '1.5em',
            marginRight: veryNarrow ? '0.25em' : '1em'
        },
    }
    const PREVIEW_LENGTH = parseInt(process.env.REACT_APP_AUDIO_PREVIEW_LENGTH)
    const account = getStorageAccount()
    const user = getAccountId()
    const { collections,
        currentCollection,
        playCurrentSong,
        playerMode, playerState, playListIndex, playTime, showCollections } = useSelector(state => state.harmonize)
    const { currentRoom, currentRoomOwner, messages, playList } = useSelector(state => state.messages)
    const { hideControls } = useSelector(state => state.playerControls)
    const { continuousPlay, reactorPlay } = useSelector(state => state.display)
    const { accessType } = currentRoom
    const isPrivateRoom = accessType === ACCESS_TYPES.PRIVATE
    const [error, setError] = useState()
    const [paused, setPaused] = useState(false)
    const [firstPlay, setFirstPlay] = useState(true)
    const [copiedUrl, setCopiedUrl] = useState()
    const [outOfCredits, setOutOfCredits] = useState(false)
    const [ownerUrl, setOwnerUrl] = useState()
    const [showSequenceStudio, setShowSequenceStudio] = useState(false)
    const dispatch = useDispatch()
    const history = useHistory()
    const player = createRef()

    const getPreviewLength = () => {
        const { highlightTime } = getPlaylistEntry()
        return highlightTime ? highlightTime + PREVIEW_LENGTH : PREVIEW_LENGTH
    }

    const getPreviewStart = () => {
        const { highlightTime } = getPlaylistEntry()
        return highlightTime ? highlightTime : 0
    }

    const displayModeSelector = () => {
        switch (playerMode) {
            default:

            case PLAYER_MODES.POST:
                return (
                    <div style={{ display: 'flex' }}>

                        <div title='Switch to swipeable' style={{ cursor: 'pointer' }}>
                            <TouchApp style={{ ...playerStyles.controlIcon, ...{ marginRight: 0 } }}
                                onClick={() => checkAccess(() => dispatch(setPlayerMode(PLAYER_MODES.SWIPE)), true)} /></div>
                    </div>
                )

            case PLAYER_MODES.SWIPE:
                return (
                    <div style={{ display: 'flex' }}>
                        <div title='Switch to full listings' style={{ cursor: 'pointer' }}>
                            <List style={{ ...playerStyles.controlIcon, ...{ marginRight: 0 } }}
                                onClick={() => checkAccess(() => dispatch(setPlayerMode(PLAYER_MODES.POST)), true)} /></div>
                    </div>
                )

        }

    }

    /**
     * Displays the Shuffle and Player mode selector buttons.
     * @returns 
     */
    const displayAdditionalControls = () => {

        const visibility = playerState === PLAYER_STATES.SONG ? 'visible' : 'hidden'
        return (
            <div style={{ display: 'flex', visibility, alignItems: 'center' }}>

                {displayModeSelector()}
            </div>
        )

    }

    /**
     * @returns 
     */
    const displayQueuePlay = () => {
        if (continuousPlay) {
            return (
                <div title='Click for Single Play' style={{ display: 'flex', cursor: 'pointer' }}>
                    <QueueMusic style={playerStyles.controlIcon} onClick={() => dispatch(setContinuousPlay(false))} /></div>)

        } else {
            return (
                <div title='Click for Continuous Play' style={{ display: 'flex', cursor: 'pointer' }}>
                    <MusicNote style={playerStyles.controlIcon} onClick={() => {
                        //dispatch(setQueuePlay(true))
                        dispatch(setContinuousPlay(true))
                    }} />
                </div>)
        }

    }
    const displayCopied = () => {
        if (copiedUrl) {
            return (
                <Snackbar
                    open={copiedUrl}
                    autoHideDuration={2000}
                    onClose={() => setCopiedUrl(false)}
                    message='Copied'
                    anchorOrigin={{ horizontal: 'center', vertical: 'bottom' }}
                >

                </Snackbar>
            )
        }
    }

    const displayCollections = () => {
        if (showCollections) {
            return (
                <div style={{
                    backgroundColor: primaryColor,
                    color: 'gold',
                    paddingTop: '0.75em',
                    paddingLeft: '0.75em'
                }}>{displayHeader()}
                    <div style={{ marginTop: '2em' }}>
                        <Playlists setCollectionPlaylist={setCollectionPlaylist} />
                    </div>
                </div>)
        }
    }

    const displayCollectionsButton = () => {
        console.log(`displayCollectionsButton ${collections.length} collections`)
        if (accessType !== ACCESS_TYPES.PUBLIC && collections.length)
            return (
                <div title={`Click to show ${showCollections ? 'Songs' : 'Playlists'}`}
                    style={{ display: 'flex', justifyContent: 'center', cursor: 'pointer', }}
                    onClick={() => checkAccess(() => dispatch(setShowCollections(!showCollections)))}><span style={{
                        border: '1px solid gold',
                        padding: '0.2em',
                        fontWeight: 'bold', borderRadius: '4px'
                    }}>{showCollections ? 'Songs' : 'Playlists'}</span></div>
            )
    }

    const displayAccessType = () => {
        switch (accessType) {
            default:
            case ACCESS_TYPES.PRIVATE:
                return <div title='Private'><Lock /></div>
            case ACCESS_TYPES.PROTECTED:
                return <div title='Protected'><LockOpen /></div>
            case ACCESS_TYPES.PUBLIC:
                return <div title='Public'><Public /></div>
        }

    }

    const isAccessAllowed = () => {
        const { accessType, user: roomOwner } = currentRoom
        return isAdminUser() ||
            accessType !== ACCESS_TYPES.PRIVATE || roomOwner === user
    }

    const displayInitHeader = () => {
        if (currentRoomOwner) {
            return (
                <div style={{ display: 'flex' }}>
                    {displayHomeIcon(history)}
                    <div style={{ display: 'flex', position: 'absolute', left: 0, width: '100%', justifyContent: 'center' }}>
                        <UserImage
                            title={`${currentRoomOwner.firstName}`}
                            image={{}}
                            style={imagesStyles.vortexProfileImageContainer}

                        />
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <TimerProgress isWhite height={5} />
                        </div>

                    </div>

                </div>
            )
        }
    }

    const displayNoAccessHeader = () => {
        return (
            <div style={{ display: 'flex' }}>
                {displayHomeIcon(history)}
                <div style={{ display: 'flex', position: 'absolute', left: 0, width: '100%', justifyContent: 'center' }}>
                    Access denied
                </div>

            </div>
        )

    }
    const displaySongHeader = (entry) => {
        if (currentRoomOwner) {
            const { img, providerImgUrl, firstName, lastName, username, handle } = currentRoomOwner
            const { name: roomName } = currentRoom
            let roomOwnerUrl = `${process.env.REACT_APP_HARMONIZE_HOST}/@${handle}`
            if (roomName.toLowerCase() !== 'home') {
                roomOwnerUrl += `/${roomName}`
            }
            return (
                <div style={{ display: 'flex' }}>
                    {displayHomeIcon(history)}
                    <div style={{ display: 'flex', position: 'absolute', left: 0, width: '100%', justifyContent: 'center' }}>

                        <UserImage
                            title={`${currentRoomOwner.firstName}`}
                            clickTitle={`Click to display ${firstName} ${lastName}`}
                            image={{ img, providerImgUrl }}
                            style={imagesStyles.vortexProfileImageContainer}
                            click={() => {
                                history.push(`/UserProfile/${username}`)
                            }}
                        />
                        <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                            <div style={{ fontSize: '0.75em', display: 'flex', alignItems: 'center', cursor: 'pointer' }}
                                onClick={() => setOwnerUrl(roomOwnerUrl)}>
                                {firstName}&nbsp;{lastName}&nbsp;@{handle}
                            </div>
                            {entry ? <span style={{ fontWeight: 'bold', fontSize: entry.name.length > 24 ? '0.75em' : '1em', paddingTop: '0.25em', paddingBottom: '0.25em' }}>{entry.name}</span> : null}
                            <div style={{ fontSize: '0.75em', display: 'flex', alignItems: 'center' }}>{displayAccessType()}&nbsp;{roomName}
                            </div>
                            {showCollections ? displayCollectionsButton() : null}
                        </div>

                    </div>

                </div>
            )
        }
    }
    const displayStudioHeader = (empty) => {
        const { img, providerImgUrl, firstName, lastName, handle } = currentRoomOwner
        const { name: roomName } = currentRoom
        return (
            <div style={{ display: 'flex' }}>
                {displayHomeIcon(history)}
                <div style={{ display: 'flex', position: 'absolute', left: 0, width: '100%', justifyContent: 'center' }}>

                    <UserImage
                        title={`${currentRoomOwner.firstName}`}
                        image={{ img, providerImgUrl }}
                        style={imagesStyles.vortexProfileImageContainer}

                    />
                    <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center' }}>
                        <div style={{ fontSize: '0.75em', display: 'flex', alignItems: 'center' }}>
                            {firstName}&nbsp;{lastName}&nbsp;@{handle}
                        </div>
                        {!empty ? <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                            <TimerProgress isWhite height={3} showTime={false} />
                        </div> : null}
                        <div style={{ fontSize: '0.75em', display: 'flex', alignItems: 'center' }}>{displayAccessType()}&nbsp;{roomName}
                        </div>
                        {showCollections ? displayCollectionsButton() : null}
                    </div>

                </div>

            </div>
        )
    }

    const displayHeader = (entry) => {
        if (!isAccessAllowed()) {
            return displayNoAccessHeader()
        } else {
            switch (playerState) {
                default:
                case PLAYER_STATES.INIT:
                    return displayInitHeader()
                case PLAYER_STATES.STUDIO:
                    return displayStudioHeader()
                case PLAYER_STATES.EMPTY_STUDIO:
                    return displayStudioHeader(true)
                case PLAYER_STATES.SONG:
                case PLAYER_STATES.MESSAGE:
                    return displaySongHeader(entry)
            }
        }
    }

    /*
        const displayPreviewWarning = () => {
            if (!showPreviewsWelcome && previewWarning && needPreviewWarning(lastPreviewWarning) && currentRoomOwner) {
                const { handle: roomOwnerHandle } = currentRoomOwner
                const { name: roomName } = currentRoom
                const message = `Your playback is limited to previews of ${PREVIEW_LENGTH} seconds. Buy streaming credits to enjoy full songs.`
                const clickMessage = 'Click to buy credits'
                const target = '/BuyCredits'
                const postBuyCreditsPage = `/@${roomOwnerHandle}/${roomName}`
                console.log(`displayPreviewWarning:\ntarget ${target} postBuyCreditsPage ${postBuyCreditsPage}`)
                return (
                    <Snackbar
                        open={previewWarning}
                        autoHideDuration={3000}
                        onClose={closePreviewWarning}
    
                        anchorOrigin={{ horizontal: 'center', vertical: 'top' }}
                    >
                        <SnackbarContent
                            style={{
                                backgroundColor: 'blue', border: '1px solid white',
                                marginTop: '5em'
                            }}
                            message={message}
                            action={<div style={{ width: '60vw', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                <Cancel onClick={closePreviewWarning} />
                                <div style={{ cursor: 'pointer', color: 'gold' }} onClick={() => {
                                    closePreviewWarning()
                                    dispatch(setPostBuyCreditsPage(postBuyCreditsPage))
                                    history.push(target)
                                }}>
                                    <i>{clickMessage}</i>
                                </div></div>} />
                    </Snackbar>
                )
    
            }
        }*/

    const displayOwnerUrl = () => {
        if (ownerUrl) {
            const message = `The URL for this studio is ${ownerUrl}`
            return (
                <Snackbar
                    open={ownerUrl}
                    autoHideDuration={5000}
                    onClose={() => setOwnerUrl()}
                    message={message}
                    anchorOrigin={{ horizontal: 'center', vertical: 'center' }}
                >

                </Snackbar>
            )
        }
    }


    const checkCredits = async () => {
        try {
            await checkCreditUsage(getPlaylistEntry(), dispatch)
        } catch (error) {
            displayError(error, setError, 5)
            //If applyCredit FAILS we still have to reset the accruedCredits array or we blow up the server
            //with a huge array. There should only be max 6 entries (with a 1 minute server update interval and a 10 second accruedCredit interval)
            dispatch(setCreditPlayTime(1))
            dispatch(setAccruedCredits([]))
            dispatch(setPreview(true))
        }
    }

    const playSong = () => {
        setFirstPlay(false)
        dispatch(setPlayCurrentSong(null))
        if (player.current) {
            currentPlayTime = Math.round(player.current.audio.current.currentTime)
        } else {
            currentPlayTime = 0
        }
        const { messageId, highlightTime, name } = getPlaylistEntry()
        console.log(`playSong ${name} paused ${paused} time ${currentPlayTime}`)
        setError('')
        if (paused) {
            setPaused(false)
        } else {

            if (account) {
                const handle = account ? account.handle : undefined
                //console.log(`onPlay send playing ${messageId}`)
                safeEmit('playing', { handle, messageId, name, currentPlayTime })
            }
            console.log(`onPlay play from time ${currentPlayTime}`)
            setPaused(false)
            dispatch(setPlayTime(0))
            dispatch(setEngaged(false))
        }
    }
    /**
     * If this is a PRIVATE studio, then it is possible to have an undefined audio source so that messages can be
     * created; otherwise, no audio source means display just a header.
     * 
     * @See https://lhz516.github.io/react-h5-audio-player/?path=/docs/layouts-advanced--stacked
     * @returns 
     */
    const displayPlayer = () => {
        //console.log(`displayPlayer playListIndex ${playListIndex}`)
        const entry = getMediaEntry('audio/mpeg')
        const videoEntry = getMediaEntry('video/mp4')
        if (entry) {
            const { source } = entry
            const { handle } = account
            //console.log(`\n---> displayPlayer firstPlay ${firstPlay} state ${playerState} source ${source}`)
            return (
                <AudioPlayer
                    ref={player}
                    crossOrigin='anonymous'
                    header={displayHeader(videoEntry.source ? videoEntry : entry)}
                    footer={displayAudioFooter(entry)}
                    autoPlayAfterSrcChange={playCurrentSong || (!firstPlay && continuousPlay)}
                    progressJumpSteps={{
                        forward: 10000,
                        backward: 10000
                    }}
                    src={source}
                    customVolumeControls={handle === 'cj' ? [<FormatListNumbered style={playerStyles.controlIcon}
                        onClick={() => {
                            dispatch(setAllowSwipe(!showSequenceStudio))
                            setShowSequenceStudio(!showSequenceStudio)
                        }
                        }
                    />] : []}
                    //showJumpControls={source !== undefined}  -- These are the next/prev/ff/rewind icons
                    customAdditionalControls={[displayAdditionalControls()]}
                    customProgressBarSection={
                        hideControls ? [] : [

                            RHAP_UI.CURRENT_TIME,
                            RHAP_UI.PROGRESS_BAR,
                            RHAP_UI.CURRENT_LEFT_TIME,
                            <DisplayCredits song={getPlaylistEntry()}
                                click={() => history.push('/BuyCredits')}
                                displayStyle={{ display: 'flex', marginTop: 0 }}
                                textStyle={{
                                    display: 'flex', height: '100%',
                                    top: 0,
                                    justifyContent: 'center',
                                    alignItems: 'center'
                                }}
                            />
                        ]
                    }
                    showFilledVolume
                    showSkipControls={true}
                    onPause={() => setPaused(true)}
                    onPlay={() => playSong()}
                    onClickNext={() => nextBlock(dispatch)}
                    onEnded={() => continuousPlay ? playNext() : {}}
                    onClickPrevious={() => previous(dispatch)}
                    onListen={() => {
                        if (player.current && player.current.audio && !paused) {
                            checkCredits()
                            currentPlayTime = Math.round(player.current.audio.current.currentTime)
                            const { accessType } = getPlaylistEntry()
                            if (isSongPreview(accessType) &&
                                (currentPlayTime > getPreviewLength()
                                    || currentPlayTime < getPreviewStart())) {
                                //player.current.audio.current.currentTime = getPreviewStart()
                                if (currentPlayTime > getPreviewLength() && continuousPlay) {
                                    playNext()
                                } else {
                                    player.current.audio.current.currentTime = getPreviewStart()
                                    player.current.audio.current.pause()
                                }
                            }
                        }
                    }}
                    /* We are ignoring these errors because the tend to occur when the page is reloaded
                       and they have no real conseuqnce we think */
                    onError={(error) => {
                        console.error('Error playing audio', error)
                        //setError(`Unable to play this audio`)
                    }}
                    onPlayError={() => {
                        console.error('PlayError playing audio', entry)
                        //setError(`Unable to play this audio (play error)`)
                    }}
                    style={{
                        backgroundColor: primaryColor,
                        color: 'gold'
                    }}
                />

            )

        }
    }


    const getActionableCollectionName = () => {
        const { name, user: collectionUser, _id } = currentCollection
        return (
            <>
                <div style={{ cursor: 'pointer', position: 'absolute', left: 0 }} title={`Click to close ${name}`}
                    onClick={(evt) => {
                        evt.stopPropagation()
                        setCollectionPlaylist()
                    }}><Close />
                </div>
                {currentCollection.name}
                {user === collectionUser ?
                    <div style={{ cursor: 'pointer', position: 'absolute', right: 10 }} title={`Click to edit ${name}`}>
                        <Edit style={{ cursor: 'pointer', margin: '0.5em' }} onClick={() => {
                            history.push(`/EditCollection/${_id}`)
                        }} /></div>
                    : null}</>
        )
    }

    /**
     * Force a sign in. We tried setForceSignIn; however when creating an account by email this resulted
     * in the dialog being hmmm OK the issue was that the Firebase dialog does not stopPropagation and
     * clicking a field was cascading down to a click listener in DisplaySignIn. We removed that
     * and problem solved. No it didn't eff it.
     */
    const doSignIn = () => {
        const { handle: roomOwnerHandle } = currentRoomOwner
        const { name } = currentRoom
        dispatch(setPostSignInPage(`/@${roomOwnerHandle}/${name}`))
        //dispatch(setForceSignIn(true))
        history.push(`/SignIn/${roomOwnerHandle}/${name}`)
    }

    /**
     * Check if either there is an account, or public performance is allowed. If not,
     * then go to the SignIn page.
     * @param {*} perform        Function to perform
     * @param {*} allowPublic    True if allowing access from PUBLIC
     */
    const checkAccess = (perform, allowPublic) => {
        console.log(`checkAccess`)
        if (account || (allowPublic && accessType === ACCESS_TYPES.PUBLIC)) {
            console.log(`checkAccess PERFORM allowPublic ${allowPublic} accessType ${accessType}`)
            perform()
        } else {
            console.log('checkAccess SignIn 1')
            doSignIn()
        }
    }

    const displayAudioFooter = () => {
        if (isAccessAllowed()) {
            switch (playerState) {
                default:
                case PLAYER_STATES.INIT:
                case PLAYER_STATES.STUDIO:
                    return null
                case PLAYER_STATES.EMPTY_STUDIO:
                    return (
                        <div>
                            {displayCollectionsButton()}</div>
                    )

            }
        }
    }

    const getPlaylistEntry = () => {
        if (playList.length) {
            return playList[playListIndex]
        } else if (isPrivateRoom && messages.length) {
            const { _id: messageId, name, userId, accessType } = messages[playListIndex]
            return { entryMedia: [{ name, messageId, userId, accessType, source: undefined, mimeType: 'audio/mpeg' }] }
        } else {
            return { entryMedia: [{ name: 'No song', messageId: 0, accessType: ACCESS_TYPES.PRIVATE, userId: '', mimeType: undefined }] }
        }
    }

    /**
     * Get the media element for the current playList entry that matches the
     * requested mimeType
     * @param {*} mt
                        * @returns The entry or if not found a dummy {source: undefined, name: '--' }
                        */
    const getMediaEntry = (mt) => {
        if (isAccessAllowed()) {
            const { entryMedia } = getPlaylistEntry()
            if (entryMedia) {
                for (const entry of entryMedia) {
                    const { mimeType } = entry
                    if (mimeType === mt) {
                        return entry
                    }
                }
            }
        }
        return { source: undefined, name: '--' }
    }

    const playNext = () => {
        if (playListIndex < playList.length - 1) {
            dispatch(setPlayListIndex(playListIndex + 1))
            const { accessType } = getPlaylistEntry()
            const startPlayTime = isSongPreview(accessType) ? getPreviewStart() : 0
            dispatch(setPlayTime(startPlayTime))
            player.current.audio.current.currentTime = startPlayTime
        } else {
            const { accessType } = getPlaylistEntry()
            if (isSongPreview(accessType)) {
                player.current.audio.current.pause()
            }
        }
    }

    const playPrevious = () => {
        if (playListIndex > 0) {
            dispatch(setPlayListIndex(playListIndex - 1))
            dispatch(setPlayTime(0))
        }
    }

    const safeEmit = (type, message) => {
        if (messageSocket()) {
            messageSocket().emit(type, message)
        }
    }

    const displaySequenceStudio = () => {
        if (showSequenceStudio) {
            return (
                <div onClick={(evt) => {
                    evt.stopPropagation()
                    setShowSequenceStudio(false)
                    dispatch(setAllowSwipe(true))
                }}>
                    <BlurDialog content={() => <SequenceStudio />} hideHelp closeIcon top='50px' />
                </div>
            )
        }
    }
    const loadMedia = async (imageEntry) => {
        const { mediaSource } = imageEntry
        console.log(`loadMedia playlistIndex ${playListIndex} ${mediaSource}`)
        if (mediaSource) {
            try {
                const data = await downloadImageFile(mediaSource)
                const src = URL.createObjectURL(data)
                setError('')
                return { src, mediaSource }
            } catch (error) {
                displayError(error, setError, 8)
            }
        }
        return null
    }

    const displayMain = () => {
        return (
            <div >
                <ErrorLine error={error} />
                {showCollections ? displayCollections() : displayPlayer()}
                {displayCopied()}
                {displayOwnerUrl()}
                {displaySequenceStudio()}

                <Footer />
            </div>
        )
    }

    useEffect(() => {
        console.log(`HarmonizePlayer useEffect playCurrentSong ${playCurrentSong}`)
        if (playCurrentSong) {
            const ix = playList.findIndex(pl => pl.name === playCurrentSong)
            if (ix !== -1) {
                console.log(`...play at ${ix}`)
                dispatch(setPlayListIndex(ix))
                playSong()
            }
        }
    }, [playCurrentSong])

    /** Reset reactorPlay on first load of page. Connect the socket listener. */
    useEffect(() => {
        console.log(`HarmonizePlayer user ${user}`)
        if (accessType !== ACCESS_TYPES.PUBLIC && user) {
            getAvailableCredits()
                .then(creditsResponse => {
                    const { availableCredits, availableArtistCredits, promotionalCredits } = creditsResponse
                    console.log(`HarmonizePlayer set availableCredits ${availableCredits}
                    availableArtistCredits ${availableArtistCredits}`)
                    //setAccount({ ...getStorageAccount(), availableCredits, availableArtistCredits })
                    dispatch(setCurrentCredits(availableCredits))
                    dispatch(setCurrentArtistCredits(availableArtistCredits))
                    dispatch(setCurrentPromotionalCredits(promotionalCredits))
                    dispatch(setPreview(isSongPreview(accessType)))
                })
                .catch(error => displayError(error, setError))
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])
    /**
     * This gets an image mediaEntry from the playList at the current playListIndex. This is so
     * that any image used in the player is correct for the current playList entry.
     */
    useEffect(() => {
        console.log(`\n *HarmonizePlayer useEffect messages ${messages.length} playListIndex ${playListIndex} playTime ${playTime}`, playList)

        dispatch(setEngaged(false))
        const { name } = getPlaylistEntry()
        if (name && name.length) {
            document.title = name
        }

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [playList, playListIndex, playerMode, reactorPlay])

    const handleVisibilityChange = () => {
        console.log(`**> HarmonizePlayer visibilityChange ${document.visibilityState} currentState ${document.visibilityState}`)
    }
    useEffect(() => {
        console.log(`**> HarmonizePlayer useEffect add visibilityChange listener visibility ${document.visibilityState}`)
        window.addEventListener('visibilitychange', handleVisibilityChange)
        return () => {
            console.log('**> HarmonizePlayer remove visibilityChange listener')
            window.removeEventListener('visibilitychange', handleVisibilityChange)
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    return displayMain()
}